export default __webpack_public_path__ + "static/media/griffon.b27f616a.jpg";